module.exports = __webpack_public_path__ + "static/Economico-ffd8f91b63eb73b1302e1a4db2376bf4.webp";